import qs from 'qs';
import queryStringParseOptions from '../queryStringParseOptions';

export const buildQueryString = params => `?${qs.stringify(params, queryStringParseOptions)}`;

export function buildQueryParams(queryString) {
  return qs.parse(queryString.replace('?', ''), queryStringParseOptions);
}
